import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import SidebarMenu from 'components/menu/SidebarMenu.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import PadLock from 'lib/components/PadLock';

import CN from './VoucherNavigation.module.scss';

const VoucherNavigation = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const salonId = useCurrentSalonId();

  return (
    <div
      data-bem="VoucherNavigation"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <header data-bem="VoucherNavigation__header" className={CN.header}>
        <SidebarMenu />
        <div className={CN.globalNav}>
          <div className={CN.pageName}>{t('voucherTracking.title')}</div>
          <nav className={CN.menuList}>
            <ul className={CN.ulScrollMenu}>
              <li>
                <NavLink to={linkTo({ pattern: LINK.vouchersTracking, params: { salonId } })} activeClassName={CN.selected}>
                  {t('voucherTracking.tracking')}
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <PadLock inMenu />
      </header>
    </div>
  );
};

export default VoucherNavigation;
